import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FaBuilding } from 'react-icons/fa';
import {
  communityDisplayName,
  communityIconUrl,
  communityLocation,
} from '../../utils/communityIdentity';

export function CommunityAvatar({ community, size = 'md', className = '' }) {
  const source = communityIconUrl(community);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => setImageFailed(false), [source]);

  return (
    <span className={`community-avatar community-avatar-${size} ${className}`.trim()} aria-hidden="true">
      {source && !imageFailed ? (
        <img src={source} alt="" loading="lazy" onError={() => setImageFailed(true)} />
      ) : (
        <FaBuilding />
      )}
    </span>
  );
}

CommunityAvatar.propTypes = {
  community: PropTypes.shape({ iconUrl: PropTypes.string, updatedAt: PropTypes.string }),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default function CommunityIdentity({
  community,
  size = 'md',
  compact = false,
  showLocation = false,
  className = '',
}) {
  const name = communityDisplayName(community);
  const location = communityLocation(community);
  return (
    <span className={`community-identity ${compact ? 'is-compact' : ''} ${className}`.trim()}>
      <CommunityAvatar community={community} size={size} />
      <span className="community-identity-copy">
        <strong>{name}</strong>
        {showLocation && location && community?.displayName !== name && <small>{location}</small>}
      </span>
    </span>
  );
}

CommunityIdentity.propTypes = {
  community: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    area: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    iconUrl: PropTypes.string,
    updatedAt: PropTypes.string,
  }),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  compact: PropTypes.bool,
  showLocation: PropTypes.bool,
  className: PropTypes.string,
};
